module.exports = {"views.headerAndSidebarLayout.sidebar.navList.item1":"Abonnements","views.headerAndSidebarLayout.sidebar.navList.item2":"Einstellungen","views.headerAndSidebarLayout.sidebar.navList.item3":"Datenschutzrichtlinie","views.headerAndSidebarLayout.sidebar.description":"Brauchen Sie Hilfe? Kontaktieren Sie uns auf","views.headerAndSidebarLayout.sidebar.customerCare":"Kundenbetreuung","views.headerAndSidebarLayout.header.signOut.text":"Abmelden","views.headerAndSidebarLayout.header.contactUs.text":"Kontaktieren Sie uns"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/de/views/HeaderAndSidebarLayout.json
// module id = 852
// module chunks = 0